<template>
  <div class="d-flex align-items-center overflow-hidden">
    <project-icon class="ml-2 mr-1" :color="item.color" />
    <div class="text-truncate label" :title="item.label" v-no-capture>
      {{ item.label }}
    </div>
  </div>
</template>

<script>
import ProjectIcon from '@/components/project/ProjectIcon.vue'

/**
 * This provides the template for the selected items in Project filter
 */
export default {
  name: 'ProjectPillTemplate',
  components: { ProjectIcon },
  props: ['item']
}
</script>

<style lang="scss" scoped>
.label {
  max-width: 120px;
}
</style>
